"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationForm = RegistrationForm;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const react_router_1 = require("react-router");
const react_intl_1 = require("react-intl");
const debounce_1 = __importDefault(require("lodash/debounce"));
const omitBy_1 = __importDefault(require("lodash/omitBy"));
const Api = __importStar(require("@src/api"));
const elements_1 = require("@src/components/elements");
const Turnstile_1 = require("@src/components/elements/Turnstile");
const DataProcessingOrNewsletterModal_1 = require("@src/components/modules/global/DataProcessingOrNewsletterModal");
const slug_offer_1 = __importDefault(require("@src/shared/slug-offer"));
const icons_1 = require("@ant-design/icons");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const types_1 = require("@src/types");
const turnstile_1 = require("@src/shared/turnstile");
const registrationFormRules_1 = require("./registrationFormRules");
const ProtectionCheckbox_1 = require("./ProtectionCheckbox");
const CompanyInformationForm_1 = require("./CompanyInformationForm");
const PersonalInformationForm_1 = require("./PersonalInformationForm");
const LoginCredentialsForm_1 = require("./LoginCredentialsForm");
const RegistrationForm_style_1 = require("./RegistrationForm.style");
const config_1 = __importDefault(require("@src/config"));
const emptyCompanyInfoFields = {
    [types_1.CompanyRegistrationFormField.street_address]: '',
    [types_1.CompanyRegistrationFormField.city]: '',
    [types_1.CompanyRegistrationFormField.postal_code]: '',
    [types_1.CompanyRegistrationFormField.country]: config_1.default.countryCode,
    [types_1.CompanyRegistrationFormField.cin]: '',
    [types_1.CompanyRegistrationFormField.tin]: '',
    [types_1.CompanyRegistrationFormField.tin_vat]: '',
    [types_1.CompanyRegistrationFormField.description]: null,
    [types_1.CompanyRegistrationFormField.website]: '',
    [types_1.CompanyRegistrationFormField.area]: '',
    [types_1.CompanyRegistrationFormField.employees]: '',
};
function RegistrationForm({ intl }) {
    const [form] = antd_1.Form.useForm();
    const history = (0, react_router_1.useHistory)();
    const [isInvitationUsed, setIsInvitationUsed] = react_1.default.useState(false);
    const [options, setOptions] = react_1.default.useState([]);
    const [companyInfo, setCompanyInfo] = react_1.default.useState({});
    const [loading, setLoading] = react_1.default.useState(false);
    const turnstileRef = (0, react_1.useRef)(null);
    const [isTurnstileSolved, setIsTurnstileSolved] = (0, react_1.useState)(false);
    // @ts-ignore
    const cit = history.getQuery && history.getQuery().cit;
    const wasInvited = Boolean(cit);
    const autoCompleteRef = react_1.default.useRef(null);
    const [showDataProcessingModal, setShowDataProcessingModal] = react_1.default.useState(false);
    const [showNewsletterModal, setShowNewsletterModal] = react_1.default.useState(false);
    const [invalidAddressError, setInvalidAddressError] = react_1.default.useState(false);
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const hasCompanyFromFinstat = Object.keys(companyInfo).length > 0 && !companyInfo.id;
    const isCompanyRegistered = Boolean(Object.keys(companyInfo).length > 0 && companyInfo.id);
    const wasNotInvitedOrInvitationWasUsed = !wasInvited || isInvitationUsed;
    const wasInvitedAndInvitationUsed = wasInvited && isInvitationUsed;
    const rules = (0, registrationFormRules_1.registrationFormRules)(intl);
    const { companyNameRules, agreementRules } = rules;
    const companyInfoInit = async () => {
        try {
            const company = await Api.Registration.getCompanyByInvitationToken(cit);
            form.setFieldsValue(company);
            setCompanyInfo(company);
        }
        catch (err) {
            setIsInvitationUsed(true);
        }
    };
    react_1.default.useEffect(() => {
        if (wasInvited) {
            companyInfoInit();
        }
    }, []);
    const onSearchChange = async (companyName) => {
        if (!companyName) {
            return;
        }
        try {
            const suggestions = await Api.Registration.getCompaniesSuggestions(companyName);
            setOptions(suggestions.map(suggestion => ({ value: suggestion.label, cin: suggestion.cin })));
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
    };
    const debouncedOnSearchChange = (0, debounce_1.default)(onSearchChange, 300);
    const loadCompanyInfo = async (value, option) => {
        try {
            if (hasCompanyFromFinstat) {
                setCompanyInfo({});
            }
            const parameterKey = option.cin ? 'cin' : 'name';
            const parameterValue = option.cin || option.value;
            const companyInfoResponse = await Api.Registration.getCompanyInfo(parameterKey, parameterValue);
            const formValues = {
                ...companyInfoResponse,
                country: companyInfoResponse.country || config_1.default.countryCode,
            };
            form.setFieldsValue(formValues);
            setCompanyInfo(companyInfoResponse);
            // @ts-ignore
            autoCompleteRef.current.blur();
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
                duration: 15,
            });
        }
    };
    const onSubmit = async (companyForm) => {
        var _a, _b;
        try {
            setInvalidAddressError(false);
            setLoading(true);
            let companyIdOrForm = companyInfo.id
                ? { ...companyForm, ...companyInfo, turnstileToken: companyForm.turnstileToken }
                : companyForm;
            const companyUrl = companyIdOrForm.company_url || new slug_offer_1.default({ text: companyIdOrForm.name }).result;
            companyIdOrForm.company_url = companyUrl;
            companyIdOrForm = (0, omitBy_1.default)(companyIdOrForm, val => val === '');
            const registrationResponse = await Api.Registration.registerCompany(cit, companyIdOrForm);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            if (registrationResponse.status === 201) {
                // @ts-ignore
                history.pushLocalized('/admin');
                antd_1.notification.success({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'registration.registration_form.registration_success',
                    }),
                });
            }
        }
        catch (error) {
            setIsTurnstileSolved(false);
            (_a = turnstileRef.current) === null || _a === void 0 ? void 0 : _a.reset();
            // eslint-disable-next-line no-console
            console.error(error);
            if (((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                setInvalidAddressError(true);
            }
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
        finally {
            setLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, layout: "vertical", initialValues: {
                    [types_1.CompanyRegistrationFormField.country]: config_1.default.countryCode,
                }, onFinish: onSubmit, autoComplete: "off", scrollToFirstError: {
                    behavior: actions => {
                        if (actions.length) {
                            const [{ el, top, left }] = actions;
                            el.scrollTop = top - 200;
                            el.scrollLeft = left;
                        }
                    },
                }, onValuesChange: changedValues => {
                    if (types_1.CompanyRegistrationFormField.turnstileToken in changedValues) {
                        setIsTurnstileSolved(Boolean(changedValues[types_1.CompanyRegistrationFormField.turnstileToken]));
                    }
                }, children: [wasInvitedAndInvitationUsed && ((0, jsx_runtime_1.jsx)(antd_1.Alert, { message: intl.formatMessage({ id: 'general.warning' }), description: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.invitation_already_used" }), type: "warning", showIcon: true, closable: true, className: "m-b-l" })), isCompanyRegistered && !wasInvited && ((0, jsx_runtime_1.jsx)(antd_1.Alert, { message: intl.formatMessage({ id: 'general.warning' }), description: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.company_already_registered", values: {
                                companyName: companyInfo.name,
                                strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                            } }), type: "warning", showIcon: true, className: "m-b-l" })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                            id: 'registration.registration_form.name',
                        }), name: types_1.CompanyRegistrationFormField.name, rules: companyNameRules, children: (0, jsx_runtime_1.jsx)(antd_1.AutoComplete, { ref: autoCompleteRef, onSearch: debouncedOnSearchChange, options: options, onSelect: loadCompanyInfo, onChange: value => {
                                const option = options.find(o => o.value === value);
                                form.setFieldsValue(emptyCompanyInfoFields);
                                setCompanyInfo({});
                                if (option) {
                                    loadCompanyInfo(value, option);
                                }
                            }, notFoundContent: intl.formatMessage({
                                id: 'registration.registration_form.no_results',
                            }), disabled: !wasNotInvitedOrInvitationWasUsed && form.getFieldValue(types_1.CompanyRegistrationFormField.name), allowClear: true, children: (0, jsx_runtime_1.jsx)(elements_1.Input, { prefix: (0, jsx_runtime_1.jsx)(icons_1.SearchOutlined, {}), placeholder: intl.formatMessage({
                                    id: 'forms.offer_notification_subscription_form.render_select.write',
                                }) }) }) }), wasNotInvitedOrInvitationWasUsed && !isCompanyRegistered && ((0, jsx_runtime_1.jsx)(CompanyInformationForm_1.CompanyInformationForm, { intl: intl, invalidAddressError: invalidAddressError, isCompanyRegistered: isCompanyRegistered, companyInfo: companyInfo, rules: rules })), (0, jsx_runtime_1.jsx)(PersonalInformationForm_1.PersonalInformationForm, { intl: intl, rules: rules }), (0, jsx_runtime_1.jsx)(LoginCredentialsForm_1.LoginCredentialsForm, { intl: intl, rules: rules, form: form, wasNotInvitedOrInvitationWasUsed: wasNotInvitedOrInvitationWasUsed }), (0, jsx_runtime_1.jsx)(ProtectionCheckbox_1.ProtectionCheckbox, { agreementRules: agreementRules, setShowDataProcessingModal: setShowDataProcessingModal }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-row", children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CompanyRegistrationFormField.newsletter, valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.newsletter" }) }) }), (0, jsx_runtime_1.jsx)(RegistrationForm_style_1.QuestionMarkWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.QuestionMark, { onClick: () => setShowNewsletterModal(true) }) })] }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CompanyRegistrationFormField.turnstileToken, validateTrigger: [], rules: [
                            {
                                required: true,
                                message: intl.formatMessage({
                                    id: 'registration.registration.not_robot_confirm',
                                }),
                            },
                        ], children: (0, jsx_runtime_1.jsx)(Turnstile_1.Turnstile, { ref: turnstileRef, siteKey: process.env.TURNSTILE_SITE_KEY, action: turnstile_1.TurnstileAction.registerCompany }) }), (0, jsx_runtime_1.jsx)(RegistrationForm_style_1.SubmitButtonWrapper, { "data-cy": "form-submit", children: (0, jsx_runtime_1.jsx)(RegistrationForm_style_1.SubmitButton, { color: "brand", htmlType: "submit", loading: loading, disabled: !isTurnstileSolved, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xxs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.register" }) }) }) }), (0, jsx_runtime_1.jsxs)(RegistrationForm_style_1.RequiredWrapper, { children: [(0, jsx_runtime_1.jsx)(RegistrationForm_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.required" })] })] }), (0, jsx_runtime_1.jsx)(DataProcessingOrNewsletterModal_1.DataProcessingOrNewsletterModal, { visible: showDataProcessingModal, setVisible: setShowDataProcessingModal, textId: "registration.registration_form.data_processing" }), (0, jsx_runtime_1.jsx)(DataProcessingOrNewsletterModal_1.DataProcessingOrNewsletterModal, { visible: showNewsletterModal, setVisible: setShowNewsletterModal, textId: "registration.registration_form.email_processing" })] }));
}
